import React from "react"
import { useIntl } from "react-intl"
import { formatPercentage } from "helpers/numbers"
import { WHITE_COLOR } from "./constants"
import { ResponsivePie } from "@nivo/pie"
import { animated } from "@react-spring/web"
import Tooltip from "./tooltip"
import { removeSpaces } from "components/Transactional/GrowthProfiling/utils"

interface PieProps {
	data: Array<any>
	colorPalette: any
}

export const Pie: React.FC<PieProps> = ({ data, colorPalette }) => {
	const intl = useIntl()
	return (
		<ResponsivePie
			data={data}
			margin={{ top: 50, right: 60, bottom: 50, left: 60 }}
			startAngle={0}
			innerRadius={0.35}
			colors={colorPalette}
			sortByValue={true}
			borderWidth={0.3}
			arcLinkLabel={(d) =>
				intl.formatMessage({
					id: `phronesis.common.${removeSpaces(d.id.toString())}`,
				})
			}
			arcLinkLabelsTextColor={{ from: "color" }}
			arcLinkLabelsThickness={3}
			arcLinkLabelsColor={{ from: "color" }}
			arcLinkLabelsSkipAngle={10}
			arcLabelsTextColor={WHITE_COLOR}
			arcLabelsComponent={({ datum, style }) => (
				<animated.g
					transform={style.transform}
					style={{ pointerEvents: "none" }}
				>
					<text
						textAnchor="middle"
						dominantBaseline="central"
						fill={style.textColor}
						fontFamily={"Bogle, serif;"}
						fontWeight={"bold"}
						fontSize={"12px"}
					>
						{formatPercentage(datum.value, 1, true)}
					</text>
				</animated.g>
			)}
			arcLabelsSkipAngle={10}
			legends={[
				{
					data: data.map((item: any, index) => {
						return {
							id: item.id,
							color: colorPalette[index],
							label: item.label ? intl.formatMessage({ id: item.label }) : "",
						}
					}),
					anchor: "bottom",
					direction: "row",
					translateX: 10,
					translateY: 50,
					itemWidth: 98,
					itemHeight: 20,
					itemsSpacing: 0,
					symbolSize: 15,
					itemDirection: "left-to-right",
				},
			]}
			tooltip={({ datum }) => (
				<Tooltip
					indexValue={datum.id.toString()}
					data={datum.data}
					color={datum.color}
				/>
			)}
		/>
	)
}
